import { useLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useRouteHelpers } from "@circle-react/routes/Main/useRouteHelpers";

export const useSidebarDisabledV3 = () => {
  const { isSpaceRoute, isSpaceGroupRoute, isFeedRoute } = useRouteHelpers();
  const isLgScreen = useLgScreenMediaQuery();

  return !isSpaceRoute && !isSpaceGroupRoute && !isFeedRoute && isLgScreen;
};
